export const LISTING_DRAFT_CREATE_ACTION_FIELD_NAME = 'action'

export const QA_NAME_LISTING_DRAFT_SAVED_AT = 'listingDraftSavedAt'

export const QA_NAME_LISTING_DRAFT_UNIT = 'listingDraftUnit'

export const QA_NAME_LISTING_DRAFT_UNTITLED = 'listingDraftUntitled'
